import { ReimbursableMealFieldEnum as Fields } from 'Common/FieldEnum';

export const DAYS_OF_THE_WEEK = [
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
  'Sun',
];

export const UNCATEGORIZED_RECIPE_CATEGORY = {
  Id: null,
  Description: 'Uncategorized',
};

export const ALACARTE_RECIPE_CATEGORY = {
  Id: 8,
  Description: 'A la Carte',
};

export const VIEW_BY = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
};

export const ANALYSIS_REQUIREMENT_DESCRIPTION_MAP = {
  'Meat/Meat Alternate': 'Meat/Meat Alt.',
  'Red/Orange Vegetables': 'Red/Orange Veg.',
  'Dark Green Vegetables': 'Dark Green Veg.',
  'Starchy Vegetables': 'Starchy Veg.',
  'Other Vegetables': 'Other Veg.',
  'Additional Vegetables': 'Additional Veg.',
};

export const VEGETABLE_CONTRIBUTION_FIELDS = [
  Fields.AdditionalVeg,
  Fields.RedOrangeVeg,
  Fields.LegumesVeg,
  Fields.StarchyVeg,
  Fields.OtherVeg,
  Fields.DarkGreenVeg,
];

export const ANALYSIS_VALUE_PRECISION = 3;

export const PROJECTED_SERVINGS_MAX_LENGTH = 6;

export const EMPTY_RECIPE_WITH_EMPTY_CONTRIBUTIONS = {
  QtyOfPortion: 0,
  ContributionsPerMeasure: {
    Fruit: 0,
    FruitJuice: 0,
    DarkGreenVeg: 0,
    RedOrangeVeg: 0,
    LegumesVeg: 0,
    StarchyVeg: 0,
    OtherVeg: 0,
    TotalVeg: 0,
    VegJuice: 0,
    WholeGrain: 0,
    EnrichedGrain: 0,
    TotalGrain: 0,
    GrainDessert: 0,
    MeatAlt: 0,
    Milk: 0,
  },
};

export const REIMBURSABLE_MEAL_TABLE_ROWS_MAP = {
  [Fields.Fruit]: {
    field: Fields.Fruit,
    label: 'Fruit',
    unit: 'cups',
  },
  [Fields.FruitJuice]: {
    field: Fields.FruitJuice,
    label: 'Fruit Juice',
    unit: 'cups',
  },
  [Fields.DarkGreenVeg]: {
    field: Fields.DarkGreenVeg,
    label: 'Dark Green Veg.',
    unit: 'cups',
  },
  [Fields.RedOrangeVeg]: {
    field: Fields.RedOrangeVeg,
    label: 'Red/Orange Veg.',
    unit: 'cups',
  },
  [Fields.LegumesVeg]: {
    field: Fields.LegumesVeg,
    label: 'Beans, Peas, Lentils Veg.',
    unit: 'cups',
  },
  [Fields.StarchyVeg]: {
    field: Fields.StarchyVeg,
    label: 'Starchy Veg.',
    unit: 'cups',
  },
  [Fields.AdditionalVeg]: {
    field: Fields.AdditionalVeg,
    label: 'Additional Veg.',
    unit: 'cups',
  },
  [Fields.OtherVeg]: {
    field: Fields.OtherVeg,
    unit: 'cups',
    label: 'Other Veg.',
  },
  [Fields.TotalVeg]: {
    field: Fields.TotalVeg,
    label: 'Total Veg.',
    unit: 'cups',
  },
  [Fields.VegJuice]: {
    field: Fields.VegJuice,
    label: 'Veg. Juice',
    unit: 'cups',
  },
  [Fields.WholeGrain]: {
    field: Fields.WholeGrain,
    label: 'Whole Grain-Rich',
    unit: 'oz. eq',
  },
  [Fields.EnrichedGrain]: {
    field: Fields.EnrichedGrain,
    label: 'Enriched Grain',
    unit: 'oz. eq',
  },
  [Fields.TotalGrain]: {
    field: Fields.TotalGrain,
    label: 'Total Grain',
    unit: 'oz. eq',
    disabled: true,
  },
  [Fields.GrainDessert]: {
    field: Fields.GrainDessert,
    label: 'Dessert',
    unit: 'oz. eq',
  },
  [Fields.MeatAlt]: {
    field: Fields.MeatAlt,
    label: 'Meat/Alt',
    unit: 'oz. eq',
  },
  [Fields.Milk]: {
    field: Fields.Milk,
    label: 'Milk',
    unit: 'cups',
  },
};



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/constants/index.js